module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429910415_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGEMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As ever, my thanks to Caroline for her support and for being there, to my parents as first readers and critics, and to Peter Lavery for that scary pencil and all those fish-and-chip suppers. Also thanks to all the usual suspects at Macmillan, including in no particular order: Stefanie Bierwerth, Dusty Miller, James Hollywell and Steve Rawlings, Jason Cooper, Chantal Noel, Vivienne Nelson, Rebecca Saunders, Liz Cowen, and many others. And further thanks to John Jarrold for casting a judicious eye over the typescript.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae2975f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429910415_ack01.vue
// module id = 69
// module chunks = 0